import { FaXTwitter } from 'react-icons/fa6';
import { CiFacebook } from 'react-icons/ci';
import { IoLogoLinkedin } from 'react-icons/io5';
import { FaQuora } from 'react-icons/fa';

import type { StrapiBlog } from '../../@types/gql/sidebar';
import { Link } from 'gatsby';



type PostTypes = {
  Slug: string;
  Thumbnail: { url: string };
  category:string|null;
  Title: string;
  publishedAt: string;
  seo: { keywords: string } | null;
};

type KeywordCount = {
  keyword: string;
  count: number;
};

const Blogsidebar = ({ sidebar }: { sidebar: StrapiBlog }) => {

  const formatDate = (dateString: string): string => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', options);
  };
  
  const displayPosts = sidebar?.slice(0, 5);

  if (!sidebar) {
    return null;
  }



  const categoryBypost = sidebar.reduce((acc, post) => {
    const category = post.category as string || "Uncategorized"; // Handle posts with no category
    acc[category] = (acc[category] || 0) + 1 as number;
    return acc;
  }, {});

  const countPostByCategory = Object.entries(categoryBypost).map(([category, count]) => ({ category, count }));


  const getKeywordsCount = (posts: PostTypes[]) => {
    const keywordsCount: Record<string, number> = {};


    posts.forEach((post) => {
      const keywords = post.seo?.keywords;
      if (keywords) {
        keywords.split(',').forEach((keyword) => {
          const trimmedKeyword = keyword.trim();
          if (trimmedKeyword) {
            keywordsCount[trimmedKeyword] =
              (keywordsCount[trimmedKeyword] || 0) + 1;
          }
        });
      }
    });

    return keywordsCount;
  };

  const keywordCount = getKeywordsCount<PostTypes[]>(sidebar);
  const convertToArray = (obj: Record<string, number>): KeywordCount[] => {
    return Object.entries(obj)
      .map(([keyword, count]) => ({ keyword, count }))
      .slice(0, 7);
  };
  const keywordArray = convertToArray(keywordCount);

  return (
    <div className="space-y-5">
      <h2 className="text-lg bg-action-btn bg-clip-text text-transparent font-bold">
        Follow Us:
      </h2>
      <div className="bg-action-btn2 h-1 w-full mb-4 mt-2" />
      <div className="flex space-x-2 bg-white pt-0 pb-4 shadow-md rounded-lg flex-wrap justify-center">
        <Link
          className="flex items-center rounded-lg px-2 py-2 bg-black text-white hover:opacity-80 focus:outline-none"
          to='https://x.com/SahilCNC'
          target='_blank'
        >
          <FaXTwitter size={25} />
        </Link>
        <Link
          className="flex items-center rounded-lg px-2 py-2 bg-[#3b5998] text-white hover:opacity-80 focus:outline-none"
          to='https://www.facebook.com/people/Sahil-CNC-Machines/61556416797746/?mibextid=ZbWKwL'
          target='_blank'
        >
          <CiFacebook size={28} />
        </Link>
        <Link
          className="flex items-center rounded-lg px-2 py-2 bg-[#007bb6] text-white hover:opacity-80 focus:outline-none"
          to="https://www.linkedin.com/company/sahil-cnc-machines/"
          target='_blank'
        >
          <IoLogoLinkedin size={28} />
        </Link>
        <Link
          className="flex items-center rounded-lg px-2 py-2 bg-[#ED001C] text-white hover:opacity-80 focus:outline-none"
          to="https://www.quora.com/profile/Sahil-CNC"
            target='_blank'
        >
          <FaQuora  size={28} />
        </Link>
      </div>
      <div className="bg-white p-4 shadow-md rounded-lg">
        {/* Header */}
        <h2 className="text-lg bg-action-btn bg-clip-text text-transparent font-bold">
          Latest Posts
        </h2>
        <div className="bg-action-btn2 h-1 w-full mb-4 mt-2" />
        {/* First Post (Highlighted) */}
        <div className="mb-6">
          <img
            alt={sidebar[0].Title}
            className="w-full h-48 object-cover rounded-lg mb-2"
            src={sidebar[0].Thumbnail.url}
          />
          {/* <div className="mb-2">
          <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
            {sidebar[0].category}
          </span>
        </div> */}
          <h3 className="text-lg font-bold line-clamp-2 overflow-hidden">
            <Link
              className="line-clamp-2 overflow-hidden"
              to={`/blog/${sidebar[0].Slug}`}
            >
              {sidebar[0].Title}
            </Link>
          </h3>
          <p className="text-gray-500 text-xs">
            by Admin - {new Date(sidebar[0].publishedAt).toLocaleDateString('en', {
                dateStyle: 'long',
              })}
          </p>
        </div>

        {/* Other Posts */}
        <div className="space-y-4">
          {/* Post 1 */}
          {displayPosts.slice(1).map((post, index) => (
            <div className="flex items-start space-x-4" key={post.Title}>
              <img
                src={post.Thumbnail.url}
                alt={post.Title}
                className="w-16 h-16 object-cover rounded-lg"
              />
              <div>
                <h4 className="text-md font-semibold">
                  <Link
                    className="font-bold text-base line-clamp-2 overflow-hidden"
                    to={`/blog/${post.Slug}`}
                  >
                    {post.Title}
                  </Link>
                </h4>
                <p className="text-gray-500 text-xs">
                {new Date(post.publishedAt).toLocaleDateString('en', {
                dateStyle: 'long',
              })}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="bg-white p-4 shadow-md rounded-lg">


        <h2 className="text-lg bg-action-btn bg-clip-text text-transparent font-bold">
          Categories
        </h2>
        <div className="bg-action-btn2 h-1 w-full mb-4 mt-2" />

  
        <ul className="space-y-3">
          {countPostByCategory.map(({category,count}, _) => (
            <li
              className="flex justify-between text-gray-700"
              key={category}
            >
              <span>{category}</span>
              <span className="text-gray-400">({count as number})</span>
            </li>
          ))}
        </ul>
      </div> */}
      {/* <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg bg-action-btn bg-clip-text text-transparent font-bold">
          Main Tags
        </h2>
        <div className="bg-action-btn2 h-1 w-full mb-4 mt-2" />
        <div className="flex items-start gap-4 flex-wrap">
          {keywordArray.map(({ keyword, count }) => (
            <button
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-normal text-xs w-[9rem] py-1 px-3 rounded-full line-clamp-1 overflow-hidden"
              key={keyword}
              type="button"
            >
              {keyword} ({count})
            </button>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default Blogsidebar;
